const STORAGE_PREFIX = 'wp-live-muted';

function storageKey(eventId) {
  return `${STORAGE_PREFIX}:${eventId}`;
}

/**
 * Reads the viewer's last explicit mute choice for this event.
 * Returns null when they have not touched the mute control in this tab.
 */
export function getLiveMutePref(eventId) {
  if (!eventId) return null;

  try {
    const stored = sessionStorage.getItem(storageKey(eventId));
    if (stored === 'true') return true;
    if (stored === 'false') return false;
    return null;
  } catch (error) {
    return null;
  }
}

export function setLiveMutePref(eventId, muted) {
  if (!eventId) return;

  try {
    sessionStorage.setItem(storageKey(eventId), muted ? 'true' : 'false');
  } catch (error) {
    // Private mode / blocked storage: preference just does not persist.
  }
}

/** Autoplay requires a muted start, so an unset preference means muted. */
export function resolveLiveMutePref(eventId) {
  const pref = getLiveMutePref(eventId);
  return pref === null ? true : pref;
}
